import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const TreeSvg = () => (
  <svg
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    {/* Foliage — three stacked clouds */}
    <path d="M12 2c-3.3 0-6 2.4-6 5.3 0 .5.1 1 .2 1.5C4.4 9.6 3 11.4 3 13.5 3 16 5 18 7.5 18h9c2.5 0 4.5-2 4.5-4.5 0-2.1-1.4-3.9-3.2-4.7.1-.5.2-1 .2-1.5C18 4.4 15.3 2 12 2z" />
    {/* Trunk */}
    <path d="M11 18h2v4h-2z" />
  </svg>
);

/** Tree icon — used for the crop-species admin page. */
export const TreeIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={TreeSvg} {...props} />
);

export default TreeIcon;
